import { Controller } from 'react-hook-form'

import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'

const Category = () => {
    const { control, watch } = useFormContextUser()
    const { categoryList } = watch()

    const computedCategories = categoryList?.map((el) => ({
        label: el.label,
        value: el.value,
    }))

    return (
        <Controller
            control={control}
            name="category"
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="select"
                    label="Catégorie"
                    type="default"
                    name={field.name}
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    placeholder="Catégorie"
                    value={field.value}
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    options={computedCategories ?? []}
                    disabled
                    locked
                    dataCyScope="UserField"
                />
            )}
        />
    )
}

export default Category
